import { DEFAULT_MODULOR_DOMAIN } from '../../constants/modulorDomain';

export const getUrlByAssetName = (
  name: string,
  theme: string,
  modulorDomain: string = DEFAULT_MODULOR_DOMAIN,
): string => {
  const formattedName = name?.replace(/-/g, '_') ?? '';
  return `https://${modulorDomain}/assets/icons/${theme}/ic_24_${formattedName}.svg`;
};
